export default __webpack_public_path__ + "static/artifakt-element-black-597002b92caef0eca020dae5430427eb.svg";